import { useContext } from "react";

import { PopoversContext } from "./PopoversContext";

export function usePopovers() {
  const context = useContext(PopoversContext);
  if (!context) {
    throw new Error("usePopovers must be used within a PopoversProvider");
  }
  return context;
}
